{
  "actions": {
    "new": "عميل جديد",
    "archive": "أرشفة",
    "restore": "استعادة",
    "newInvoice": "فاتورة جديدة",
    "recordReceipt": "تسجيل سند قبض",
    "newQuotation": "عرض سعر جديد",
    "newCreditNote": "إشعار دائن جديد",
    "newDebitNote": "إشعار مدين جديد",
    "statement": "كشف الحساب",
    "printStatement": "طباعة كشف الحساب",
    "credit": "الرصيد غير المستخدم والمبالغ المستردة",
    "open": "فتح",
    "rowActions": "إجراءات {{name}}",
    "export": "تصدير العرض",
    "retryFigures": "إعادة تحميل الرصيد"
  },
  "fields": {
    "code": "الرمز",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "company": "الشركة",
    "mobile": "الهاتف المحمول",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "address": "العنوان",
    "city": "المدينة",
    "country": "الدولة",
    "status": "الحالة",
    "groups": "المجموعات",
    "taxNumber": "الرقم الضريبي",
    "notes": "ملاحظات",
    "createdAt": "تاريخ الإنشاء",
    "updatedAt": "آخر تعديل",
    "contactName": "الاسم",
    "role": "الصفة",
    "balance": "الرصيد",
    "overdue": "المتأخر",
    "unallocatedCredit": "رصيد غير مستخدم"
  },
  "status": {
    "ACTIVE": "نشط",
    "INACTIVE": "غير نشط",
    "ARCHIVED": "مؤرشف",
    "ANONYMISED": "مجهول الهوية"
  },
  "list": {
    "title": "العملاء",
    "tableLabel": "العملاء",
    "views": "طرق عرض العملاء",
    "view": {
      "current": "الكل",
      "active": "النشطون",
      "inactive": "غير النشطين",
      "archived": "المؤرشفون"
    },
    "searchLabel": "البحث في العملاء",
    "searchPlaceholder": "ابحث بالاسم أو الرمز أو الهاتف…",
    "clearSearch": "مسح البحث",
    "groupFilter": "التصفية حسب المجموعة",
    "allGroups": "كل المجموعات",
    "clearFilters": "مسح عوامل التصفية",
    "empty": {
      "title": "لا يوجد عملاء بعد.",
      "body": "أضف عميلك الأول لتبدأ البيع بالآجل.",
      "filteredTitle": "لا يوجد عملاء مطابقون.",
      "filteredBody": "جرّب اسمًا أو رمزًا أو رقم هاتف آخر، أو امسح عوامل التصفية.",
      "view": {
        "current": "لا يوجد عملاء بعد.",
        "active": "لا يوجد عملاء نشطون.",
        "inactive": "لا يوجد عملاء غير نشطين.",
        "archived": "لا يوجد عملاء مؤرشفون."
      },
      "balance": {
        "owes": "لا يوجد عميل عليه مستحقات.",
        "overdue": "لا توجد مبالغ متأخرة.",
        "credit": "لا يوجد عميل له رصيد."
      }
    },
    "balanceView": {
      "owes": "عليهم مستحقات",
      "overdue": "متأخرون في السداد",
      "credit": "لهم رصيد"
    },
    "inCredit": "له رصيد: للعميل علينا {{amount}}",
    "overdueMarker": "جزء منه متأخر",
    "exportHint_zero": "ملف CSV فارغ: لا عملاء في طريقة العرض هذه",
    "exportHint_one": "ملف CSV بعميل واحد في طريقة العرض هذه",
    "exportHint_two": "ملف CSV بعميلَين في طريقة العرض هذه",
    "exportHint_few": "ملف CSV بـ{{n}} عملاء في طريقة العرض هذه",
    "exportHint_many": "ملف CSV بـ{{n}} عميلًا في طريقة العرض هذه",
    "exportHint_other": "ملف CSV بـ{{n}} عميل في طريقة العرض هذه",
    "stats": {
      "label": "أرقام العملاء",
      "active": "العملاء النشطون",
      "ofAll": "من {{total}}",
      "activeShare": "{{percent}}٪ من العملاء نشطون",
      "owed": "المستحق لنا",
      "owedDetail": "على {{customers}}",
      "overdueShare": "{{percent}}٪ مما على العملاء متأخر",
      "overdue": "المتأخر",
      "credit": "أرصدة العملاء لدينا",
      "unavailable": "الأرقام غير متاحة",
      "customers_zero": "لا عملاء",
      "customers_one": "عميل واحد",
      "customers_two": "عميلان",
      "customers_few": "{{n}} عملاء",
      "customers_many": "{{n}} عميلًا",
      "customers_other": "{{n}} عميل"
    }
  },
  "detail": {
    "noContacts": "لا توجد جهات اتصال بعد.",
    "noContactsHint": "عدّل العميل لإضافة الأشخاص الذين تتعامل معهم."
  },
  "new": {
    "title": "عميل جديد",
    "subtitle": "يُخصَّص رمز العميل عند الحفظ."
  },
  "edit": {
    "title": "تعديل {{name}}",
    "subtitle": "تعديل العميل",
    "archivedTitle": "هذا العميل مؤرشف",
    "backToCustomer": "العودة إلى العميل"
  },
  "form": {
    "save": "حفظ العميل",
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "sections": {
      "identity": "الهوية",
      "contact": "الاتصال",
      "address": "العنوان",
      "classification": "التصنيف",
      "taxNotes": "الضريبة والملاحظات",
      "contacts": "جهات الاتصال"
    },
    "hints": {
      "company": "الاسم القانوني أو التجاري، إن كان مختلفًا عن اسم العميل.",
      "groupsUnavailable": "تعذّر تحميل المجموعات. يمكنك إضافتها لاحقًا.",
      "contacts": "الأشخاص الذين تتعامل معهم لدى هذا العميل."
    },
    "groupsPlaceholder": "اختر المجموعات",
    "groupsSearch": "ابحث في المجموعات…",
    "groupsEmpty": "لا توجد مجموعات.",
    "groupsClear": "مسح الاختيار",
    "groupsSelected": "{{n}} مجموعات",
    "noContacts": "لا توجد جهات اتصال بعد.",
    "addContact": "إضافة جهة اتصال",
    "contactName": "اسم جهة الاتصال {{n}}",
    "contactPhone": "هاتف جهة الاتصال {{n}}",
    "contactRole": "صفة جهة الاتصال {{n}}",
    "removeContact": "إزالة جهة الاتصال {{n}}",
    "errors": {
      "title": "لم يُحفظ العميل",
      "mobileTaken": "رقم الهاتف المحمول هذا مستخدم لعميل آخر.",
      "archived": "استعد هذا العميل قبل تعديله.",
      "pricingForbidden": "تحديد مستوى سعر العميل، أو إضافة مجموعة تحدد الأسعار أو إزالتها، يتطلب صلاحية إدارة مجموعات العملاء أو الأسعار. تراجع عن هذا التغيير، أو اطلبه ممن يملك الصلاحية."
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا العميل",
      "body": "لم تُحفظ تغييراتك. أعد التحميل لعرض أحدث نسخة، ثم أعد إجراء تغييراتك.",
      "reload": "تحميل أحدث نسخة"
    },
    "leave": {
      "title": "تجاهل التغييرات غير المحفوظة؟",
      "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
      "confirm": "تجاهل التغييرات",
      "cancel": "متابعة التعديل"
    }
  },
  "archive": {
    "title": "أرشفة {{name}}؟",
    "body": "يخرج العملاء المؤرشفون من قائمة العملاء ومن قوائم الاختيار، ولا يمكن استخدامهم في المستندات الجديدة. يبقون في طريقة العرض «المؤرشفون»، ويمكنك استعادتهم في أي وقت.",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يعود العميل إلى القوائم ويمكن استخدامه في المستندات الجديدة مرة أخرى."
  },
  "toast": {
    "created": "تم إنشاء العميل {{code}}",
    "updated": "تم حفظ العميل",
    "archived": "تمت أرشفة العميل",
    "restored": "تمت استعادة العميل",
    "exported_zero": "لم يُصدَّر أي عميل",
    "exported_one": "تم تصدير عميل واحد",
    "exported_two": "تم تصدير عميلَين",
    "exported_few": "تم تصدير {{n}} عملاء",
    "exported_many": "تم تصدير {{n}} عميلًا",
    "exported_other": "تم تصدير {{n}} عميل",
    "exportedView": "تم تصدير العرض"
  },
  "groups": {
    "title": "مجموعات العملاء",
    "subtitle": "صنّف العملاء في مجموعات لقوائم الأسعار والتقارير والتصفية.",
    "new": "مجموعة جديدة",
    "newTitle": "مجموعة عملاء جديدة",
    "newSubtitle": "سمِّ المجموعة بلغة واحدة أو باللغتين.",
    "editTitle": "تعديل مجموعة العملاء",
    "save": "حفظ المجموعة",
    "actions": "إجراءات",
    "editNamed": "تعديل {{name}}",
    "deleteNamed": "حذف {{name}}",
    "showMembers": "عرض العملاء في {{name}}",
    "showArchivedMembers": "عرض العملاء المؤرشفين في {{name}}",
    "archivedMembers_zero": "لا عملاء مؤرشفين",
    "archivedMembers_one": "+ عميل مؤرشف واحد",
    "archivedMembers_two": "+ عميلان مؤرشفان",
    "archivedMembers_few": "+{{n}} عملاء مؤرشفين",
    "archivedMembers_many": "+{{n}} عميلًا مؤرشفًا",
    "archivedMembers_other": "+{{n}} عميل مؤرشف",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "description": "الوصف",
      "members": "العملاء",
      "allowTillCredit": "السماح بالبيع الآجل في نقطة البيع",
      "allowTillCreditHint": "يمكن للأعضاء الشراء على الحساب في نقطة البيع: يبقى ما لا يدفعونه مستحقًا على الفاتورة. لا يُطبَّق حد ائتماني.",
      "tillCredit": "آجل في نقطة البيع"
    },
    "empty": {
      "title": "لا توجد مجموعات عملاء بعد.",
      "body": "أنشئ مجموعات مثل الجملة أو الجهات الحكومية لتصفية العملاء وإعداد التقارير عنهم."
    },
    "errors": {
      "nameTaken": "توجد مجموعة بهذا الاسم بالفعل.",
      "versionConflict": "غيّر شخص آخر هذه المجموعة بعد أن فتحتها. أغلقها وافتحها مجددًا لترى التغيير."
    },
    "delete": {
      "title": "حذف {{name}}؟",
      "body_zero": "ستُحذف المجموعة. لا يوجد عملاء فيها.",
      "body_one": "ستُزال المجموعة من عميل واحد. يبقى العميل نفسه دون تغيير.",
      "body_two": "ستُزال المجموعة من عميلَين. يبقى العميلان دون تغيير.",
      "body_few": "ستُزال المجموعة من {{n}} عملاء. يبقى العملاء أنفسهم دون تغيير.",
      "body_many": "ستُزال المجموعة من {{n}} عميلًا. يبقى العملاء أنفسهم دون تغيير.",
      "body_other": "ستُزال المجموعة من {{n}} عميل. يبقى العملاء أنفسهم دون تغيير.",
      "level": "ويفقد عملاؤها مستوى السعر {{level}} الذي تمنحهم إياه، فيشترون بمستواهم الخاص أو بمستوى مجموعة أخرى أو بالتجزئة.",
      "confirm": "حذف المجموعة"
    },
    "toast": {
      "created": "تم إنشاء المجموعة",
      "updated": "تم حفظ المجموعة",
      "deleted": "تم حذف المجموعة"
    }
  },
  "picker": {
    "placeholder": "اختر عميلًا",
    "search": "ابحث بالاسم أو الرمز أو الهاتف…",
    "empty": "لا يوجد عميل مطابق.",
    "failed": "تعذّر تحميل العملاء. حاول مرة أخرى."
  },
  "archiveBlocked": {
    "balance": "سدّد أولًا الرصيد المستحق البالغ {{amount}}.",
    "credit": "استرد أولًا الرصيد البالغ {{amount}} أو طبّقه.",
    "openCredit": "طبّق أولًا الرصيد غير المستخدم البالغ {{amount}} على الفواتير المفتوحة.",
    "checking": "جارٍ التحقق من الرصيد…",
    "unavailable": "تعذّر تحميل الرصيد."
  },
  "errors": {
    "CUSTOMER_HAS_BALANCE": "على هذا العميل مبالغ مستحقة أو له رصيد غير مستخدم. سدّد الرصيد المستحق، واسترد الرصيد غير المستخدم أو طبّقه، ثم أرشفه.",
    "CUSTOMER_HAS_BALANCE_SALES_OFF": "ما زال على هذا العميل مبلغ مستحق أو لديه رصيد، وتسويته تتم في المبيعات. وحدة المبيعات متوقفة لشركتك: بعد إعادة تشغيلها سوِّ الرصيد ثم أرشِف العميل.",
    "WALK_IN_CUSTOMER": "لا يمكن أرشفة العميل النقدي.",
    "CUSTOMER_HAS_OPEN_CHEQUES": "لدى هذا العميل شيكات مستلمة ما زالت في الصندوق أو مودَعة ولم تُصرف بعد. أرشِفه بعد صرفها، أو بعد تسجيل ارتجاعها أو إعادتها إليه.",
    "GROUP_IN_USE_zero": "لم تعد لهذه المجموعة أسعار مخصصة. حاول حذفها مرة أخرى.",
    "GROUP_IN_USE_one": "لهذه المجموعة سعر مخصص. احذفه من صفحة منتجه أولًا، ثم احذف المجموعة.",
    "GROUP_IN_USE_two": "لهذه المجموعة سعران مخصصان. احذفهما من صفحات المنتجات أولًا، ثم احذف المجموعة.",
    "GROUP_IN_USE_few": "لهذه المجموعة {{customPrices}} أسعار مخصصة. احذفها من صفحات المنتجات أولًا، ثم احذف المجموعة.",
    "GROUP_IN_USE_many": "لهذه المجموعة {{customPrices}} سعرًا مخصصًا. احذفها من صفحات المنتجات أولًا، ثم احذف المجموعة.",
    "GROUP_IN_USE_other": "لهذه المجموعة {{customPrices}} سعر مخصص. احذفها من صفحات المنتجات أولًا، ثم احذف المجموعة."
  },
  "profile": {
    "figures": "أرقام الحساب",
    "balanceDue": "الرصيد المستحق",
    "inCredit": "له رصيد",
    "overdue": "المتأخر",
    "oldest": "أقدمه {{bucket}}",
    "nothingOverdue": "لا شيء متأخر",
    "creditHeld": "رصيد غير مستخدم",
    "creditSources_zero": "لا مستندات",
    "creditSources_one": "في مستند واحد",
    "creditSources_two": "في مستندين",
    "creditSources_few": "في {{count}} مستندات",
    "creditSources_many": "في {{count}} مستندًا",
    "creditSources_other": "في {{count}} مستند",
    "lastInvoice": "آخر فاتورة",
    "lastReceipt": "آخر سند قبض",
    "netSalesHead": "صافي المبيعات",
    "invoiceCount_zero": "لا فواتير",
    "invoiceCount_one": "فاتورة واحدة، قبل الضريبة",
    "invoiceCount_two": "فاتورتان، قبل الضريبة",
    "invoiceCount_few": "{{count}} فواتير، قبل الضريبة",
    "invoiceCount_many": "{{count}} فاتورة، قبل الضريبة",
    "invoiceCount_other": "{{count}} فاتورة، قبل الضريبة",
    "none": "لا يوجد بعد",
    "aging": "أعمار الرصيد المستحق",
    "agingCurrency": "ر.ع.",
    "agingFailed": "تعذّر تحميل أعمار الرصيد.",
    "agingUnavailable": "أعمار الرصيد غير متاحة.",
    "nothingOwed": "لا مستحقات",
    "figuresFailed": "تعذّر تحميل أرقام الحساب.",
    "bucket": {
      "current": "غير مستحق",
      "days1to30": "1–30",
      "days31to60": "31–60",
      "days61to90": "61–90",
      "over90": "90+"
    },
    "bucketLong": {
      "days1to30": "⁦1–30⁩ يومًا",
      "days31to60": "⁦31–60⁩ يومًا",
      "days61to90": "⁦61–90⁩ يومًا",
      "over90": "أكثر من 90 يومًا"
    },
    "tabs": {
      "label": "أقسام العميل",
      "overview": "نظرة عامة",
      "invoices": "الفواتير",
      "receipts": "سندات القبض",
      "creditNotes": "الإشعارات الدائنة",
      "quotations": "عروض الأسعار",
      "statement": "كشف الحساب",
      "tasks": "المهام",
      "attachments": "المرفقات"
    },
    "walkIn": "نقدي",
    "archivedBanner": "أُرشف في {{date}}. لا يمكن استخدامه في مستندات جديدة، وتبقى سجلاته متاحة للاطلاع.",
    "inactiveBanner": "غير نشط: لا فواتير ولا إشعارات مدينة ولا عروض أسعار جديدة. أما سندات القبض والإشعارات الدائنة والمبالغ المستردة فمتاحة لتسوية الأرصدة القديمة.",
    "attention": {
      "title": "يحتاج إلى متابعة",
      "none": "لا شيء يحتاج إلى متابعة.",
      "unavailable": "غير متاح.",
      "overdue_zero": "فواتير متأخرة",
      "overdue_one": "فاتورة متأخرة",
      "overdue_two": "فاتورتان متأخرتان",
      "overdue_few": "فواتير متأخرة",
      "overdue_many": "فاتورة متأخرة",
      "overdue_other": "فاتورة متأخرة",
      "drafts_zero": "مسودات فواتير بانتظار الترحيل",
      "drafts_one": "مسودة فاتورة بانتظار الترحيل",
      "drafts_two": "مسودتا فاتورة بانتظار الترحيل",
      "drafts_few": "مسودات فواتير بانتظار الترحيل",
      "drafts_many": "مسودة فاتورة بانتظار الترحيل",
      "drafts_other": "مسودة فاتورة بانتظار الترحيل",
      "draftNotes_zero": "مسودات إشعارات دائنة بانتظار الترحيل",
      "draftNotes_one": "مسودة إشعار دائن بانتظار الترحيل",
      "draftNotes_two": "مسودتا إشعار دائن بانتظار الترحيل",
      "draftNotes_few": "مسودات إشعارات دائنة بانتظار الترحيل",
      "draftNotes_many": "مسودة إشعار دائن بانتظار الترحيل",
      "draftNotes_other": "مسودة إشعار دائن بانتظار الترحيل",
      "pending_zero": "عروض أسعار بانتظار الاعتماد",
      "pending_one": "عرض سعر بانتظار الاعتماد",
      "pending_two": "عرضا سعر بانتظار الاعتماد",
      "pending_few": "عروض أسعار بانتظار الاعتماد",
      "pending_many": "عرض سعر بانتظار الاعتماد",
      "pending_other": "عرض سعر بانتظار الاعتماد",
      "credit": "رصيد غير مستخدم — طبّقه على الفواتير أو استرده"
    },
    "recent": {
      "title": "أحدث المستندات",
      "none": "لا توجد مستندات بعد."
    },
    "kind": {
      "invoice": "فاتورة",
      "receipt": "سند قبض",
      "creditNote": "إشعار دائن",
      "debitNote": "إشعار مدين"
    },
    "sections": {
      "contact": "الاتصال",
      "address": "العنوان",
      "classification": "التصنيف",
      "notes": "ملاحظات",
      "contacts": "جهات الاتصال",
      "record": "السجل"
    },
    "noContact": "لا يوجد هاتف محمول أو هاتف أو بريد إلكتروني أو شركة مسجّلة.",
    "showAllNotes": "عرض الكل"
  },
  "docs": {
    "views": {
      "invoices": {
        "label": "طرق عرض الفواتير",
        "all": "الكل",
        "open": "المفتوحة",
        "overdue": "المتأخرة",
        "draft": "المسودات",
        "void": "المُبطَلة"
      },
      "receipts": {
        "label": "طرق عرض سندات القبض",
        "all": "الكل",
        "credit": "فيها رصيد غير مستخدم",
        "void": "المُبطَلة"
      },
      "creditNotes": {
        "label": "طرق عرض الإشعارات الدائنة",
        "all": "الكل",
        "credit": "فيها رصيد غير مستخدم",
        "draft": "المسودات",
        "void": "المُبطَلة"
      },
      "quotations": {
        "label": "طرق عرض عروض الأسعار",
        "all": "الكل",
        "pending": "قيد الانتظار",
        "approved": "المعتمدة",
        "converted": "المحوّلة",
        "rejected": "المرفوضة"
      }
    },
    "kindFilter": "التصفية حسب النوع",
    "allKinds": "الفواتير والإشعارات المدينة",
    "empty": {
      "invoices": "لا توجد فواتير لهذا العميل بعد.",
      "receipts": "لا توجد سندات قبض من هذا العميل بعد.",
      "creditNotes": "لا توجد إشعارات دائنة لهذا العميل بعد.",
      "quotations": "لا توجد عروض أسعار لهذا العميل بعد.",
      "view": "لا شيء في طريقة العرض هذه.",
      "next": {
        "invoices": "أنشئ أول فاتورة، أو حوّل عرض سعر معتمدًا.",
        "receipts": "سجّل سند قبض عندما يدفع العميل.",
        "creditNotes": "أصدر إشعارًا دائنًا لمرتجع أو تخفيض سعر من فاتورة.",
        "quotations": "أرسل إلى العميل عرض سعر."
      }
    },
    "rowActions": "إجراءات {{number}}",
    "draft": "مسودة",
    "open": "فتح",
    "edit": "تعديل",
    "post": "ترحيل…",
    "delete": "حذف المسودة…",
    "void": "إبطال…",
    "print": "معاينة الطباعة",
    "recordReceipt": "تسجيل سند قبض",
    "creditNote": "إشعار دائن",
    "allocate": "التطبيق على الفواتير…",
    "refund": "استرداد الرصيد",
    "convert": "التحويل إلى فاتورة…"
  },
  "credit": {
    "title": "رصيد غير مستخدم",
    "held": "الإجمالي {{amount}}",
    "sources": "مستندات فيها رصيد غير مستخدم",
    "sourcesHint": "سندات القبض والإشعارات الدائنة التي فيها مبالغ لم تُطبَّق على فواتير ولم تُسترد بعد.",
    "none": "لا يوجد رصيد غير مستخدم.",
    "truncated": "تظهر الأحدث فقط.",
    "available": "غير مستخدم",
    "allocate": "تطبيق",
    "refund": "استرداد",
    "refunds": "المبالغ المستردة",
    "noRefunds": "لا توجد مبالغ مستردة بعد.",
    "allRefunds": "كل المبالغ المستردة لهذا العميل",
    "source": {
      "RECEIPT": "سند قبض",
      "CREDIT_NOTE": "إشعار دائن"
    },
    "applyTo": "تطبيق {{number}} على الفواتير",
    "refundFrom": "استرداد من {{number}}"
  },
  "quickCreate": {
    "action": "عميل جديد",
    "title": "عميل جديد",
    "body": "الأساسيات الآن، والباقي في صفحة العميل.",
    "save": "إضافة العميل",
    "created": "أُضيف العميل {{name}}",
    "later": "يمكن إضافة العنوان والمجموعات والرقم الضريبي وجهات الاتصال في صفحة العميل.",
    "actionTyped": "عميل جديد «{{typed}}»"
  },
  "anonymised": {
    "label": "عميل مجهول الهوية {{code}}",
    "bannerTitle": "أُخفيت هويته في {{date}}",
    "bannerBody": "حُذفت البيانات الشخصية لهذا العميل وفق سياسة الاحتفاظ بالبيانات. لم يبقَ في سجله إلا الرمز، ولا يمكن تعديله أو استعادته.",
    "editNotice": "أُخفيت هوية العميل {{code}} ولا يمكن تعديله."
  },
  "priceLevel": {
    "label": "مستوى السعر",
    "inherit": "حسب المجموعة (أو التجزئة)",
    "inheritFrom": "حسب المجموعة: {{level}} ({{group}})",
    "inheritNone": "حسب المجموعة: لا مستوى، فالتجزئة",
    "inheritHint": "مستوى مجموعاته، والتجزئة إن لم تحدد أي مجموعة مستوى",
    "none": "بلا مستوى",
    "noneHint": "يشتري الأعضاء بمستواهم الخاص، وإلا فبالتجزئة",
    "customerHint": "الأسعار التي تستخدمها الفواتير وعروض الأسعار ونقاط البيع لهذا العميل.",
    "readOnlyHint": "تغييره يتطلب صلاحية إدارة مجموعات العملاء أو الأسعار.",
    "groupHint": "يشتري عملاء هذه المجموعة بهذا المستوى، ما لم يكن لأحدهم مستوى خاص به.",
    "fromGroup": "{{level}} · حسب مجموعته",
    "fromGroupNamed": "{{level}} · حسب مجموعة {{group}}",
    "fact": "أسعار {{level}}",
    "factFromGroup": "أسعار {{level}} · حسب المجموعة"
  },
  "customPrices": {
    "title": "الأسعار المخصصة",
    "empty": "لا توجد بعد. تُحدَّد الأسعار المخصصة من صفحة المنتج.",
    "exVat": "الأسعار قبل الضريبة.",
    "perUnit": "لكل {{unit}}",
    "from": "من {{date}}",
    "until": "حتى {{date}}",
    "between": "{{from}} – {{to}}",
    "shown": "يُعرض {{shown}} من {{total}}."
  },
  "salesperson": {
    "label": "مدير الحساب",
    "hint": "مندوب المبيعات الذي تُنسب إليه مبيعات العميل الجديدة ما لم يحدد المستند غيره.",
    "none": "بلا مدير حساب"
  }
}
